import { render, staticRenderFns } from "./CreateQn.vue?vue&type=template&id=ded44144&scoped=true&"
import script from "./CreateQn.vue?vue&type=script&lang=js&"
export * from "./CreateQn.vue?vue&type=script&lang=js&"
import style0 from "./CreateQn.vue?vue&type=style&index=0&id=ded44144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded44144",
  null
  
)

export default component.exports